import React from 'react';
import {motion} from 'framer-motion';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const {FiMapPin, FiPhone, FiMail, FiFileText, FiCamera} = FiIcons;

const ImpressumPage = () => {
  return (
    <div className="pt-20">
      {/* Hero Section */}
      <section className="relative py-20 bg-gradient-to-br from-[#3466ad] to-[#2a5291] text-white">
        <div className="absolute inset-0 bg-gradient-to-r from-black/20 via-black/10 to-black/20"></div>
        <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <motion.div
            initial={{opacity: 0, y: 30}}
            animate={{opacity: 1, y: 0}}
            transition={{duration: 0.8}}
          >
            <div className="flex justify-center mb-6">
              <div className="w-16 h-16 bg-white/20 backdrop-blur-sm rounded-xl flex items-center justify-center">
                <SafeIcon icon={FiFileText} className="w-8 h-8 text-white" />
              </div>
            </div>
            <h1 className="text-4xl md:text-5xl font-bold mb-4">
              Impressum
            </h1>
            <p className="text-xl opacity-90">
              Angaben gemäß § 5 TMG
            </p>
          </motion.div>
        </div>
      </section>

      {/* Main Content */}
      <section className="py-20 bg-white">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <motion.div
            initial={{opacity: 0, y: 30}}
            whileInView={{opacity: 1, y: 0}}
            viewport={{once: true}}
            transition={{duration: 0.8}}
            className="space-y-12"
          >
            {/* Company Information */}
            <div className="bg-gray-50 rounded-2xl p-8 shadow-sm">
              <div className="flex items-start space-x-4 mb-6">
                <div className="w-12 h-12 bg-[#3466ad] rounded-xl flex items-center justify-center flex-shrink-0">
                  <SafeIcon icon={FiMapPin} className="w-6 h-6 text-white" />
                </div>
                <div>
                  <h2 className="text-2xl font-bold text-gray-900 mb-4">
                    Angaben gemäß § 5 TMG
                  </h2>
                  <div className="text-lg text-gray-700 space-y-1">
                    <p className="font-semibold">Valentina Schneider</p>
                    <p>Wassenbergerstr. 41</p>
                    <p>52525 Heinsberg</p>
                  </div>
                </div>
              </div>
            </div>

            {/* Contact Information */}
            <div className="bg-gray-50 rounded-2xl p-8 shadow-sm">
              <div className="flex items-start space-x-4">
                <div className="w-12 h-12 bg-[#3466ad] rounded-xl flex items-center justify-center flex-shrink-0">
                  <SafeIcon icon={FiPhone} className="w-6 h-6 text-white" />
                </div>
                <div>
                  <h2 className="text-2xl font-bold text-gray-900 mb-4">
                    Kontakt
                  </h2>
                  <div className="space-y-3">
                    <div className="flex items-center space-x-3">
                      <SafeIcon icon={FiPhone} className="w-5 h-5 text-[#3466ad]" />
                      <div>
                        <p className="text-sm text-gray-600">Telefon</p>
                        <a
                          href="tel:+4924528607019"
                          className="text-lg text-gray-900 hover:text-[#3466ad] transition-colors font-medium"
                        >
                          02452 860 70 19
                        </a>
                      </div>
                    </div>
                    <div className="flex items-center space-x-3">
                      <SafeIcon icon={FiMail} className="w-5 h-5 text-[#3466ad]" />
                      <div>
                        <p className="text-sm text-gray-600">E-Mail</p>
                        <a
                          href="mailto:info@rudtbau.de"
                          className="text-lg text-gray-900 hover:text-[#3466ad] transition-colors font-medium"
                        >
                          info@rudtbau.de
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* Tax Information */}
            <div className="bg-gray-50 rounded-2xl p-8 shadow-sm">
              <h2 className="text-2xl font-bold text-gray-900 mb-4">
                Umsatzsteuer-ID
              </h2>
              <div className="text-gray-700 space-y-2">
                <p className="leading-relaxed">
                  Umsatzsteuer-Identifikationsnummer gemäß § 27 a Umsatzsteuergesetz:
                </p>
                <div className="pl-4 space-y-1">
                  <p><span className="font-semibold">Steuernummer:</span> 210/5146/2645</p>
                  <p><span className="font-semibold">IdNr:</span> 64843790257</p>
                </div>
              </div>
            </div>

            {/* Photographer Credit */}
            <div className="bg-gray-50 rounded-2xl p-8 shadow-sm">
              <div className="flex items-start space-x-4">
                <div className="w-12 h-12 bg-[#3466ad] rounded-xl flex items-center justify-center flex-shrink-0">
                  <SafeIcon icon={FiCamera} className="w-6 h-6 text-white" />
                </div>
                <div>
                  <h2 className="text-2xl font-bold text-gray-900 mb-4">
                    Bildnachweis
                  </h2>
                  <div className="text-gray-700 space-y-2">
                    <p className="leading-relaxed">
                      Fotografie auf dieser Website:
                    </p>
                    <div className="pl-4">
                      <p className="font-semibold">David Scherrers</p>
                      <a
                        href="https://fodeo.de"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="text-[#3466ad] hover:text-[#2a5291] transition-colors font-medium"
                      >
                        Fodeo.de
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* Dispute Resolution */}
            <div className="bg-gray-50 rounded-2xl p-8 shadow-sm">
              <h2 className="text-2xl font-bold text-gray-900 mb-4">
                Verbraucher­streit­beilegung/Universal­schlichtungs­stelle
              </h2>
              <p className="text-gray-700 leading-relaxed">
                Wir sind nicht bereit oder verpflichtet, an Streitbeilegungsverfahren vor einer
                Verbraucherschlichtungsstelle teilzunehmen.
              </p>
            </div>

            {/* Additional Information */}
            <div className="bg-blue-50 border-l-4 border-[#3466ad] rounded-r-2xl p-8">
              <h3 className="text-lg font-semibold text-gray-900 mb-3">
                Hinweis zur Rechtswirksamkeit
              </h3>
              <p className="text-gray-700 leading-relaxed">
                Alle Angaben sind nach bestem Wissen und Gewissen erstellt. Für die Richtigkeit,
                Vollständigkeit und Aktualität der Inhalte können wir jedoch keine Gewähr übernehmen.
              </p>
            </div>
          </motion.div>
        </div>
      </section>
    </div>
  );
};

export default ImpressumPage;